import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';

const ProductButtons = ({onAngebotButtonClick, onMehrButtonClick}) => {


  const [showMore, setShowMore] = useState(false);

  const handleMehrButtonClick = () => {
    onMehrButtonClick();
    setShowMore(!showMore);
  }

  const handleAngebotButtonClick = () => {
    onAngebotButtonClick();
  }
  return (
    <div className="">
      {/* Product action buttons (e.g., Add to Cart, View Details) */}
      <button className="btn btn-primary mr-2 btn-showmore" onClick={handleMehrButtonClick} style={{marginTop: '10px'}}>
        {!showMore ? <><FontAwesomeIcon style={{paddingRight:10}} icon={faAngleDown} /> MEHR ANZEIGEN</> : <><FontAwesomeIcon style={{paddingRight:10}} icon={faAngleUp} /> WENIGER ANZEIGEN</>}
      </button>
      <button className="btn btn-secondary btn-contact" onClick={handleAngebotButtonClick} style={{marginTop: '10px'}}>JETZT ZUM ANGEBOT</button>
    </div>
  );
};

export default ProductButtons;
